import { render, staticRenderFns } from "./ChatMessaging.vue?vue&type=template&id=4541b678"
import script from "./ChatMessaging.vue?vue&type=script&lang=js"
export * from "./ChatMessaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports